import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link } from "react-router-dom";
import "./Helpchat.css";
import Contact from "./Contact";

const ChefPartySupport = () => {
  const [expandBoost, setExpandBoost] = useState(false);
  const expandBoostfunc = () => {
    setExpandBoost(!expandBoost);
  };

  const [openCollapse, setOpenCollapse] = useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
  });

  const handleCollapseToggle = (collapseKey) => {
    setOpenCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === collapseKey ? !prevState[key] : false;
        return acc;
      }, {}),
    }));
  };
  return (
    <div className="ps-2">
      <div>
        <p style={{ color: "blue", fontWeight: "500" }}>
          नमस्कार, हम यहां आपकी मदद के लिए हैं।
        </p>
        <p style={{ color: "#ff5c09" }}>सुझाव :</p>
        <ul style={{ fontSize: "12px", lineHeight: "20px" }}>
          <li>
            अपनी प्रोफ़ाइल अपडेट करें और उसे 100% पूरा करें: अपनी प्रोफ़ाइल को
            पूरी तरह से अपडेट करें, जिसमें आपका स्थान, विशेषज्ञता, व्यंजन,
            उपलब्धता और कोई खास रीक्वारेमेंटएं शामिल हों। इससे नियोक्ता आपको
            आसानी से ढूंढ सकेंगे और आपसे संपर्क करेंगे। (""मेरी प्रोफ़ाइल
            संपादित करें"" पर क्लिक करें)
          </li>
          <li>
            नियमित रूप से आवेदनों की जांच करें: जितनी बार हो सके आवेदनों की जांच
            करें। जल्दी संपर्क करने से आप अन्य शेफों को पछाड़ सकते हैं। आपकी
            प्रोफ़ाइल को भी अधिक दिखावट मिलेगी, जिससे आपको अधिक नौकरी के अवसर
            मिल सकते हैं।
          </li>
          <li>
            केवल उन्हीं नौकरियों या इवेंट्स के लिए आवेदन करें जो आपकी विशेषज्ञता
            और उपलब्धता से मेल खाते हों: अपना समय और प्रयास बचाने और प्रासंगिक
            अवसरों से अधिक प्रतिक्रियाएँ प्राप्त करने के लिए, केवल उन नौकरियों
            या इवेंट्स के लिए आवेदन करें जो आपकी प्रोफ़ाइल से मेल खाते हों।
          </li>
        </ul>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open1")}
          aria-controls="example-fade-text"
          aria-expanded={openCollapse.open1}
          className="help"
        >
          प्रोफ़ाइल
        </p>
        <Collapse in={openCollapse.open1}>
          <div id="example-fade-text">
            <p style={{ fontSize: "12px" }}>
              अपनी प्रोफ़ाइल को अपडेट करें और नियोक्ताओं द्वारा खोजे जाने और
              उनसे संपर्क किए जाने की अधिक संभावनाएं बढ़ाएं।
            </p>
            <Link
              to="/hin/cook/edit-cook-profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              बेसिक प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/hin/cook/edit-chef-profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              शेफ प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/hin/cook/edit-party-profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              पार्टी प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/hin/cook/edit-cook-profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              डीपी अपडेट करें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open2")}
          aria-controls="example-fade-text1"
          aria-expanded={openCollapse.open2}
          className="mt-3 help"
        >
          जॉब्स
        </p>
        <Collapse in={openCollapse.open2}>
          <div id="example-fade-text1">
            <Link
              to="/hin/cook/jobs"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              नौकरियां खोजें
            </Link>
            <Link
              onClick={expandBoostfunc}
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              प्रोफ़ाइल बूस्ट करें
            </Link>
            {expandBoost && (
              <p style={{ fontSize: "12px" }}>
                अधिक प्रतिक्रियाएं प्राप्त करने के लिए कुछ दिनों के लिए अपनी
                प्रोफ़ाइल को बढ़ाएं। इसके लिए मामूली शुल्क देना होगा।
                <Link to="/hin/cook/plans">Continue (Plans)</Link>
              </p>
            )}
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open3")}
          aria-controls="example-fade-text2"
          aria-expanded={openCollapse.open3}
          className="mt-3 help"
        >
          इवेंट्स
        </p>
        <Collapse in={openCollapse.open3}>
          <div id="example-fade-text2">
            <p style={{ fontSize: "12px" }}>
              क्लाइंट्स को रुचि भेजें और उनसे संपर्क करें: अपना आवेदन जल्दी
              मंजूर कराने के लिए, उन क्लाइंट्स को सीधे अपनी रुचि भेजें जो आपके
              प्रोफाइल से मेल खाते हों और उनसे संपर्क करें।
            </p>
            <Link
              to="/hin/cook/find-events"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              इवेंट्स खोजें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open4")}
          aria-controls="example-fade-text3"
          aria-expanded={openCollapse.open4}
          className="mt-3 help"
        >
          संपर्क सेटिंग्स
        </p>
        <Collapse in={openCollapse.open4}>
          <div id="example-fade-text3">
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              व्हाट्सऐप जोड़ें
            </Link>
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              मोबाइल नंबर बदलें
            </Link>
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              ईमेल बदलें
            </Link>
            <Link
              to="/hin/cook/settings"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              संपर्क गोपनीयता
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open5")}
          aria-controls="example-fade-text4"
          aria-expanded={openCollapse.open5}
          className="mt-3 help"
        >
          हमसे संपर्क करें
        </p>
        <Collapse in={openCollapse.open5}>
          <div id="example-fade-text4">
            <Contact />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ChefPartySupport;
